import { createDynamicSlice } from ".";
import { getSettingListThunk } from "../thunks/settingsThunk";

export const settingsSlice = createDynamicSlice({
  name: "settings",
  thunk: getSettingListThunk,
  listMode: true,
  resetActionName: "resetSettings",
});

export const settingsReducer = settingsSlice.reducer;
export const { resetSettings } = settingsSlice.actions;
